import { render, staticRenderFns } from "./EditProductionModal.vue?vue&type=template&id=f45cd79a&"
import script from "./EditProductionModal.vue?vue&type=script&lang=js&"
export * from "./EditProductionModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports